import { initContract } from "@ts-rest/core";
import {
    LogStreamEventQuerySchema,
    LogStreamEventResponseSchema,
} from "../schemas/logStreamEvent.schema";

export {
    LogStreamEventSchema,
    LogStreamEventQuerySchema,
    LogStreamEventResponseSchema,
} from "../schemas/logStreamEvent.schema";

export type {
    LogStreamEventQuery,
    LogStreamEventResponse,
} from "../schemas/logStreamEvent.schema";

const c = initContract();

export const logStreamEventContract = c.router(
    {
        getLogStreamEvents: {
            method: "GET",
            path: "/",
            query: LogStreamEventQuerySchema,
            responses: {
                200: LogStreamEventResponseSchema,
            },
        },
    },
    {
        pathPrefix: "/log-stream-event",
    },
);
